import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { ProductService } from '@teem/app/core/services/product.service';
import { messages as i18n } from '@teem/constants/messages';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-category-modal',
  templateUrl: './add-category-modal.component.html',
  styleUrls: ['./add-category-modal.component.scss']
})
export class AddCategoryModalComponent implements OnInit {
  form: FormGroup;
  @Input() type: string = 'product';  
  ngOnInit(): void {
  }

  constructor(
    private fb: FormBuilder,
    private productService: ProductService,
    public activeModal: NgbActiveModal,
    private loaderService: LoaderService
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      name_ar: ['']
    });
  }

  submit() {
    if (this.form.invalid) return;
    
    this.form.addControl('type', new FormControl(this.type));
    console.log(this.type)
    this.productService.updateCreateCategory(this.form.value).subscribe(data => {
      this.loaderService.stopLoading();
      this.form.reset();
      this.activeModal.close(data);
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }
}
